import { Injectable, Injector } from '@angular/core';
import Dexie from 'dexie';
import { wrapAllMethodsWithLogging } from '../core/decorators/log-all-errors.decorator';
import { LoggingService } from './logging.service';

export class DigitalEyesDb extends Dexie {
  public InspectionFilesDetails: Dexie.Table; // id is number in this case
  public InspectionTaskDetails: Dexie.Table;
  public privateDetectTable: Dexie.Table;
  public constructor() {
    super("DigitalEyesDb");
    this.version(1).stores({
      InspectionFilesDetails: "++InspectionFileId,ImgFileIdForAudio,TaskID,UserID,zoneDetails,FileType,LocalFileUrl,FileSize,FileName,UploadStatus,RetryHitting,MetaData,ServerFileID,ServerFileName,LiveUrl",
      InspectionTaskDetails: "++Id,TaskID,ServerData,ServerDataKeys,UIBindings,UntaggedImages",
      privateDetectTable: "++Id,blobData"
    });
    this.version(2).stores({
      InspectionFilesDetails:
        "++InspectionFileId,taskId,UserID,fileType,LocalFileUrl,FileSize,fileName," +
        "UploadStatus,retryHitting,metadata,ServerFileID,ServerFileName,CaptureDate,zonedetails,filePath"
    });
    this.InspectionFilesDetails = this.table("InspectionFilesDetails");
    this.InspectionTaskDetails = this.table("InspectionTaskDetails");
    this.privateDetectTable = this.table("privateDetectTable");
  }
}

@Injectable({
  providedIn: 'root'
})

export class LocalDbService {
  db: any;
  componentName: string = 'local-db';
  constructor(private injector: Injector) {
    wrapAllMethodsWithLogging(this, this.componentName, this.injector, LoggingService);
  }

  async truncateData() {
    this.db = new DigitalEyesDb();
    await this.db.InspectionFilesDetails.clear();
    await this.db.InspectionTaskDetails.clear();
    await this.db.privateDetectTable.clear();
  }

  async addInspectionFilesDetails1(obj) {
    this.db = new DigitalEyesDb();

    this.db.transaction('rw', this.db.InspectionFilesDetails, async () => {
      // if ((await this.db.InspectionFilesDetails.where({ TaskID: 'DYSFBTSK14' }).count()) === 0) {
      const id = await this.db.InspectionFilesDetails.add(obj);
      console.log(`Added friend with id ${id}`);
    }).catch(e => {
      alert(e.stack || e);
    });
  }

  async addInspectionFilesDetails(obj) {
    this.db = new DigitalEyesDb();
    const id = await this.db.InspectionFilesDetails.add(obj);
    console.log(`Added file with id ${id}`);
  }

  assignData(taskDetails) {
    let items: any = [];
    taskDetails.forEach(element => {
      items.push({
        InspectionFileId: element.InspectionFileId,
        ImgFileIdForAudio: element.ImgFileIdForAudio,
        TaskID: element.TaskID,
        UserID: element.UserID,
        zoneDetails: element.zoneDetails,
        FileType: element.FileType,
        LocalFileUrl: element.LocalFileUrl,
        FileSize: element.FileSize,
        FileName: element.FileName,
        UploadStatus: element.UploadStatus.toString(),
        RetryHitting: element.RetryHitting,
        MetaData: element.MetaData,
        ServerFileID: element.ServerFileID,
        ServerFileName: element.ServerFileName,
        LiveUrl: element.LiveUrl
      });
    });

    return items;
  }

  async getTaskFileDetailsToUploadOld(TaskID, maxHitCounter) {
    this.db = new DigitalEyesDb();
    const taskDetails = await this.db.InspectionFilesDetails.where("TaskID").equals(TaskID).and(item => item.RetryHitting <= maxHitCounter && item.UploadStatus == 'false').toArray();
    if (taskDetails.length > 0) {
      return this.assignData(taskDetails);
    }
    else {
      alert('Error getTaskFileDetailsToUpload')
    }
  }

  async getTaskFileDetailsToUpload(taskId, maxHitCounter) {
    this.db = new DigitalEyesDb();
    return await this.db.InspectionFilesDetails.where("taskId").equals(taskId).and(item => item.retryHitting <= maxHitCounter && item.UploadStatus == 'false').toArray();
  }

  async getsyncUnsyncTaskFileDetails(TaskID, UploadStatus = false) {
    this.db = new DigitalEyesDb();

    const taskDetails = await this.db.InspectionFilesDetails.where("taskId").equals(TaskID).and(item => item.UploadStatus == UploadStatus).toArray();
    if (taskDetails.length > 0) {
      return this.assignData(taskDetails);
    }
    else {
      alert('Error getsyncUnsyncTaskFileDetails')
    }
  }

  async getUnsyncFilesWithMaxRetry(TaskID, maxHitCounter) {
    this.db = new DigitalEyesDb();
    return await this.db.InspectionFilesDetails.where("taskId").equals(TaskID).and(item => item.RetryHitting >= maxHitCounter && item.UploadStatus == 'false').toArray();
    // const taskDetails = await this.db.InspectionFilesDetails.where("taskId").equals(TaskID).and(item => item.RetryHitting >= maxHitCounter && item.UploadStatus == 'false').toArray();
    // if (taskDetails.length > 0) {
    //   return this.assignData(taskDetails);
    // }
    // else{
    //   alert('Error getUnsyncFilesWithMaxRetry')
    // }
  }

  async getAllFileDetailsByInspectionFileId(InspectionFileId = null) {
    this.db = new DigitalEyesDb();
    const taskDetails = await this.db.InspectionFilesDetails.where("InspectionFileId").equals(InspectionFileId).toArray();
    if (taskDetails.length > 0) {
      return this.assignData(taskDetails);
    }
    else {
      alert('Error getAllFileDetailsByInspectionFileId')
    }
  }

  async getAllFileDetailsByTaskID(TaskID = null) {
    this.db = new DigitalEyesDb();
    const taskDetails = await this.db.InspectionFilesDetails.where("TaskID").equals(TaskID).toArray();
    if (taskDetails.length > 0) {
      return this.assignData(taskDetails);
    }
    else {
      alert('Error getAllFileDetailsByTaskID')
    }
  }

  updateHitCount(InspectionFile, hitCount) {
    this.db = new DigitalEyesDb();

    this.db.InspectionFilesDetails.update(InspectionFile.InspectionFileId, { RetryHitting: hitCount }).then(function (updated) {
      if (updated) {
        console.log("Counter update for File ID: ", InspectionFile.InspectionFileId);
        return updated;
      }
      else
        console.log("FileID not found. Nothing was updated");
    });
  }

  updateFileDetails(InspectionFile, uploadFileDetails) {
    this.db = new DigitalEyesDb();
    var uploadStatus = uploadFileDetails.StatusCode == 200 ? true : false;

    this.db.InspectionFilesDetails.update(InspectionFile.InspectionFileId, { UploadStatus: uploadStatus, ServerFileName: uploadFileDetails.Data[0].fileName }).then(function (updated) {
      if (updated) {
        console.log("Counter update for File ID: ", InspectionFile.InspectionFileId);
        return updated;
      }
      else
        console.log("FileID not found. Nothing was updated");
    });
  }

  fileStatusChange(InspectionFile, uploadFileDetails) {
    this.db = new DigitalEyesDb();
    var uploadStatus = uploadFileDetails;
    this.db.InspectionFilesDetails.update(InspectionFile.InspectionFileId, { UploadStatus: uploadStatus }).then(function (updated) {
      if (updated) {
        return true;
      }
      else {
        return false;
      }
    });
  }

  async deleteInspectionFiles(InspectionFileId) {
    this.db = new DigitalEyesDb();
    var deleteCount = await this.db.InspectionFilesDetails.where("InspectionFileId").equals(InspectionFileId).delete();
    if (deleteCount) {
      return true;
    }
    else {
      return false;

    }
  }

  async deleteInspectionFilesByFileName(FileName) {
    this.db = new DigitalEyesDb();
    var deleteCount = await this.db.InspectionFilesDetails.where("FileName").equals(FileName).delete();
    if (deleteCount) {
      return true;
    }
    else {
      return false;
    }
  }

  async deleteTaskFilesFromLocal(TaskID) {
    this.db = new DigitalEyesDb();
    var deleteCount = await this.db.InspectionFilesDetails.where("TaskID").equals(TaskID).delete();
    if (deleteCount) {
      return true;
    }
    else {
      return false;
    }
  }

  async getAllInspectionFilesDetails() {
    // return await this._localDbService.getAll('InspectionFilesDetails').toPromise();
  }

  async getAllFileDetailsBytaskId(taskId = null) {
    this.db = new DigitalEyesDb();
    return await this.db.InspectionFilesDetails.where("taskId").equals(taskId).toArray();
  }

  async getLatestImageAndCount(taskId = null) {
    this.db = new DigitalEyesDb();
    const allFiles = await this.db.InspectionFilesDetails.where("taskId").equals(taskId)
      .and(file => file.captureType === 'original')
      .toArray();

    const images = allFiles.filter(f => f.fileType === 'images');

    images.sort((a, b) =>
      new Date(b.CaptureDate).getTime() - new Date(a.CaptureDate).getTime()
    );

    return {
      latest: images[0] || null,
      count: images.length,
    };
  }


  updateFileDetailsNew(InspectionFile, uploadFileDetails) {
    this.db = new DigitalEyesDb();
    console.log('Update File details', { uploadFileDetails: uploadFileDetails });
    var uploadStatus = uploadFileDetails.StatusCode == 200 ? 'true' : 'false';
    // var LocalFileUrl = uploadStatus == 'true' ? '' : InspectionFile.LocalFileUrl;

    this.db.InspectionFilesDetails.update(InspectionFile.InspectionFileId, { UploadStatus: uploadStatus, ServerFileName: uploadFileDetails.Data[0].serverFileName }).then(function (updated) {
      if (updated) {
        console.log('Update for File ID:', InspectionFile.InspectionFileId);
        return true;
      }
      else {
        console.log('FileID not found. Nothing was updated');
        return false;
      }
    });
  }

  async deleteInspectionFilesbytaskId(taskId) {
    this.db = new DigitalEyesDb();
    var deleteCount = await this.db.InspectionFilesDetails.where("TaskID").equals(taskId).delete();
    if (deleteCount) {
      return true;
    }
    else {
      return false;
    }
  }

  async deleteTaskFilesFromLocalNew(taskId) {
    this.db = new DigitalEyesDb();
    var deleteCount = await this.db.InspectionFilesDetails.where("TaskID").equals(taskId).delete();
    var deleteCount1 = await this.db.InspectionTaskDetails.where("TaskID").equals(taskId).delete();
    if (deleteCount && deleteCount1) {
      return true;
    }
    else {
      return false;
    }
  }

  async addInspectionFilesTemplate(obj) {
    this.db = new DigitalEyesDb();
    this.db.transaction('rw', this.db.InspectionTaskDetails, async () => {
      if ((await this.db.InspectionTaskDetails.where({ TaskID: obj.taskId }).count()) !== 0) {
        const taskDetailsId = await this.db.InspectionTaskDetails.get({ TaskID: obj.taskId });
        await this.updateTaskTemplate(taskDetailsId.Id, obj);
      } else {
        setTimeout(async () => {
          const id = await this.db.InspectionTaskDetails.add(obj);
          console.log(`Added Task with id ${id}`);
        }, 200);
      }
    }).catch(e => {
      console.error(e.stack || e);
    });
  }

  updateTaskTemplate(Id, obj) {
    this.db = new DigitalEyesDb();
    this.db.InspectionTaskDetails.update(Id, { ServerData: obj.ServerData, ServerDataKeys: obj.ServerDataKeys, UIBindings: obj.UIBindings, UntaggedImages: obj.UntaggedImages, noCatImageReason: obj.noCatImageReason, ServerDataQues: obj.ServerDataQues }).then(function (updated) {
      if (updated) {
        console.log('Update for Task ID:', obj.taskId);
        return updated;
      }
      else
        console.log('FileID not found. Nothing was updated');
    });
  }

  async updateTaskNoReason(taskId, value) {
    this.db = new DigitalEyesDb();
    const taskDetailsId = await this.db.InspectionTaskDetails.get({ TaskID: taskId });
    this.db.InspectionTaskDetails.update(taskDetailsId.Id, { noCatImageReason: value }).then(function (updated) {
      if (updated) {
        console.log("Update for Task ID: ", taskId);
        return updated;
      }
      else
        console.log('FileID not found. Nothing was updated');
    });
  }

  async updateTemplateQues(taskId, value) {
    this.db = new DigitalEyesDb();
    const taskDetailsId = await this.db.InspectionTaskDetails.get({ TaskID: taskId });
    this.db.InspectionTaskDetails.update(taskDetailsId.Id, { ServerDataQues: value }).then(function (updated) {
      if (updated) {
        console.log("Update for Task ID: ", taskId);
        return updated;
      }
      else
        console.log('FileID not found. Nothing was updated');
    });
  }

  async getTaskServerData(taskId) {
    this.db = new DigitalEyesDb();
    return await this.db.InspectionTaskDetails.where("TaskID").equals(taskId).toArray();
  }

  async addInspectionDeviceDetails(inputdevice) {
    this.db = new DigitalEyesDb();
    const id = await this.db.InspectionDeviceDetails.add(inputdevice);
    console.log(`Added device with id ${id}`);
  }

  async getInspectionDeviceDetails() {
    this.db = new DigitalEyesDb();
    return await this.db.InspectionDeviceDetails.toArray();
  }

  async getUserLoginDetails(agentId) {
    this.db = new DigitalEyesDb();
    return await this.db.LoginDetails.where("UserID").equals(agentId).toArray();
  }

  async addUserLoginDetails(obj) {
    this.db = new DigitalEyesDb();
    const id = await this.db.LoginDetails.add(obj);
  }

  async updateUserLoginDetails(agentId, sessionId, Id) {
    this.db = new DigitalEyesDb();
    await this.db.LoginDetails.update(Id, { SessionID: sessionId }).where("UserID").equals(agentId).then(function (updated) {
      if (updated) {
        return true;
      }
      else
        return false;
    });
  }

  async hasPendingUploads(taskId: any): Promise<boolean> {
    if (!taskId || typeof taskId === 'object') {
      console.error('hasPendingUploads called with invalid taskId:', taskId);
      return false;
    }
    this.db = new DigitalEyesDb();
    const files = await this.db.InspectionFilesDetails
      .where('taskId').equals(taskId)
      .and(f => f.captureType === 'original')
      .toArray();
    return files.some(f => f.UploadStatus !== true);
  }
  async insertdummyblob(obj) {
    this.db = new DigitalEyesDb();
    var ids = await this.db.privateDetectTable.add(obj).then(function (res) {
      return res;
    }, err => {
      return 'private window'
    });
    return ids;
    // console.log(`Added friend with id ${ids}`); 
    // return ids;
  }
}

